<template>
  <div class="sign-in-container__logo">
    <img aria-label="Logo"
      :src="this.localUrl"
    >
  </div>
</template>

<script>
export default {
  props: {
    logoUrl: { type: String }
  },
  computed: {
    localUrl () {
      if (!this.logoUrl) { return 'http://designsystem.morningstar.com/images/sandbox/sample-pages/mstar-logo.svg' }
      return this.logoUrl
    }
  },
  name: 'FormLogo'
}
</script>
